var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronleftBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.50367C9 6.37643 8.97348 6.25899 8.92043 6.15133C8.86149 6.04367 8.77308 5.9409 8.65521 5.84303L1.76817 0.249577C1.56778 0.0831925 1.32613 6.70871e-07 1.04322 6.95604e-07C0.848722 7.12607e-07 0.674852 0.03915 0.521611 0.117449C0.362475 0.190853 0.235756 0.29362 0.141454 0.425749C0.0471514 0.552984 -1.22072e-07 0.694899 -1.08382e-07 0.851497C-8.78464e-08 1.08639 0.109037 1.29437 0.327112 1.47544L6.5334 6.50367L0.327113 11.5319C0.109038 11.713 8.59127e-07 11.9185 8.79234e-07 12.1485C8.93352e-07 12.31 0.0471525 12.4544 0.141455 12.5816C0.235757 12.7088 0.362476 12.8091 0.521612 12.8826C0.674853 12.9609 0.848723 13 1.04322 13C1.32613 13 1.56778 12.9193 1.76817 12.7578L8.65521 7.16431C8.77308 7.06644 8.86149 6.96367 8.92043 6.85601C8.97348 6.74835 9 6.63091 9 6.50367Z",
    fill: "#151833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronleftBackButton);
export default __webpack_public_path__ + "static/media/chevron.leftBackButton.2599914e8444de923f3b4c4667634df9.svg";
export { ForwardRef as ReactComponent };